var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-toggle flex-center"},[_c('a',{attrs:{"title":_vm.title},on:{"click":function($event){return _vm.setLanguage()}}},[_c('span',{staticClass:"flag-icon flag-icon-large",class:_vm.flag})])])
}
var staticRenderFns = []

export { render, staticRenderFns }